// ---------------------------------------------------------------------------
// Local device-only auth session (legacy TVs / when Clerk is unavailable).
// - Lightweight profile stored in localStorage; zero network, zero SDK deps
// - Used by AuthContext in "local" mode so profile/watchlist still function
// ---------------------------------------------------------------------------

const KEY = 'flexwatch_local_session';

const readSession = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.id) return null;
    return parsed;
  } catch (e) {
    return null;
  }
};

const writeSession = (session) => {
  try {
    if (session) {
      localStorage.setItem(KEY, JSON.stringify(session));
    } else {
      localStorage.removeItem(KEY);
    }
  } catch (e) {
    /* storage full / private mode — session simply won't persist */
  }
  return session;
};

const localAuth = {
  getSession: readSession,

  isSignedIn: () => Boolean(readSession()),

  signIn: async ({ name } = {}) => {
    const displayName = String(name || '').trim() || 'Guest Viewer';
    const session = {
      id: 'local-' + Date.now().toString(36),
      fullName: displayName,
      firstName: displayName.split(' ')[0],
      emailAddresses: [{ emailAddress: 'local@device' }],
      primaryEmailAddress: { emailAddress: 'local@device' },
      imageUrl: null,
      signedInAt: new Date().toISOString(),
    };
    return writeSession(session);
  },

  signOut: async () => {
    writeSession(null);
    return null;
  },
};

export default localAuth;
